/* eslint-disable @typescript-eslint/no-explicit-any */
import { PHONE_REGEXP, SHIPPING_METHOD } from '@/constants'
import * as Yup from 'yup'

export const translateSchema = (schemaName: string, translate?: any) => {
  let schemaValidation
  switch (schemaName) {
    case 'register':
      return Yup.object().shape({
        phone: Yup.string()
          .matches(PHONE_REGEXP, translate('phoneVldFormat'))
          .min(10, translate('phoneVldFormat'))
          .max(11, translate('phoneVldFormat'))
          .required(translate('required')),
        name: Yup.string().required(translate('nameRequired')),
        preference: Yup.boolean().isTrue(translate('preferenceRequired')),
      })
    case 'addShippingAddress':
      return Yup.object().shape({
        phone: Yup.string()
          .matches(PHONE_REGEXP, translate('phoneVldFormat'))
          .min(10, translate('phoneVldFormat'))
          .max(11, translate('phoneVldFormat'))
          .required(translate('required')),
        name: Yup.string().required(translate('nameRequired')),
        provinceCode: Yup.string().required(translate('provinceRequired')),
        // Yup v1: `.when()` truyền field value dưới dạng mảng [value], do đó cần truy cập ?.[0]
        districtCode: Yup.string().when('areaType', (areaType:any, schema: any) => {
          if ((areaType as any)?.[0] === 'old') {
            return schema.required(translate('districtRequired'))
          }
          return schema
        }),
        wardCode: Yup.string().required(translate('wardRequired')),
        address: Yup.string().required(translate('addressRequired')),
        preference: Yup.boolean().isTrue(translate('preferenceRequired')),
      })
    case 'editShippingAddress':
      return Yup.object().shape({
        phone: Yup.string()
          .matches(PHONE_REGEXP, translate('phoneVldFormat'))
          .min(10, translate('phoneVldFormat'))
          .max(11, translate('phoneVldFormat'))
          .required(translate('required')),
        name: Yup.string().required(translate('nameRequired')),
        provinceCode: Yup.string().required(translate('provinceRequired')),
        districtCode: Yup.string().when('areaType', (areaType:any, schema: any) => {
          if ((areaType as any)?.[0] === 'old') {
            return schema.required(translate('districtRequired'))
          }
          return schema
        }),
        wardCode: Yup.string().required(translate('wardRequired')),
        address: Yup.string().required(translate('addressRequired')),
      })
    case 'searchOrder':
      return Yup.object().shape({
        phone: Yup.string()
          .min(10, translate('phoneVldFormat'))
          .max(11, translate('phoneVldFormat'))
          .required(translate('required')),
      })
    case 'chooseDestination':
      return Yup.object().shape({
        provinceCode: Yup.string().required(translate('provinceRequired')),
        wardCode: Yup.string().required(translate('districtRequired')),
      })
    case 'contact':
      return Yup.object().shape({
        phone: Yup.string()
          .matches(PHONE_REGEXP, translate('phoneVldFormat'))
          .min(10, translate('phoneVldFormat'))
          .max(11, translate('phoneVldFormat'))
          .required(translate('required')),
        name: Yup.string().required(translate('nameRequired')),
      })
    case 'searchOrderOtp':
      return Yup.object().shape({
        otp: Yup.string()
          .min(4, translate('otpVldInvalid'))
          .max(4, translate('otpVldInvalid'))
          .required(translate('otpRequire')),
      })
    case 'otp':
      return Yup.object().shape({
        otp: Yup.string()
          .min(4, translate('otpVldInvalid'))
          .max(4, translate('otpVldInvalid'))
          .required(translate('otpRequire')),
      })
    case 'login':
      return Yup.object().shape({
        phone: Yup.string()
          .min(10, translate('phoneVldFormat'))
          .max(11, translate('phoneVldFormat'))
          .required(translate('required')),
      })
    case 'reviewProduct':
      return Yup.object().shape({
        point: Yup.number().required(translate('ratePointRequired')),
      })
    case 'checkoutCart':
      return Yup.object().shape({
        phone: Yup.string()
          .matches(PHONE_REGEXP, translate('phoneVldFormat'))
          .min(10, translate('phoneVldFormat'))
          .max(11, translate('phoneVldFormat'))
          .required(translate('phoneRequired')),
        name: Yup.string().required(translate('nameRequired')),
        preference: Yup.boolean(),
        alternateName: Yup.string().when(
          'preference',
          (preference:any, schema: any) => {
            if (preference[0])
              return schema.required(translate('alternateNameRequired'))
            return schema
          }
        ),
        alternatePhone: Yup.string().when(
          'preference',
          (preference:any, schema: any) => {
            if (preference[0])
              return schema
                .matches(PHONE_REGEXP, translate('phoneVldFormat'))
                .min(10, translate('phoneVldFormat'))
                .max(11, translate('phoneVldFormat'))
                .required(translate('phoneRequired'))
            return schema
          }
        ),
        invoiceName: Yup.string().when('vat', (vat:any, schema: any) => {
          if (vat[0]) return schema.required(translate('invoiceNameRequired'))
          return schema
        }),
        invoiceAddress: Yup.string().when('vat', (vat:any, schema: any) => {
          if (vat[0])
            return schema.required(translate('invoiceAddressRequired'))
          return schema
        }),
        invoiceType: Yup.string().when('vat', (vat, schema: any) => {
          if (vat[0]) return schema.required(translate('required'))
          return schema
        }),
        invoiceTaxNumber: Yup.string().when(
          ['vat', 'invoiceType'],
          (values: any[], schema: any) => {
            const [vat, invoiceType] = values
            if (!vat) return schema

            let regex = /^(\d{10,13}|\d{10}-\d{3})$/
            let errMsg = translate('invoiceTaxNumberInvalid')

            if (invoiceType === 'household') {
              regex = /^\d{10}(-\d{3})?$|^\d{12}$/
              errMsg = translate('invoiceTaxNumberInvalidHousehold')
            } else if (invoiceType === 'company') {
              regex = /^\d{10}(-\d{3})?$/
              errMsg = translate('invoiceTaxNumberInvalidCompany')
            }

            return schema
              .required(translate('invoiceTaxNumberRequired'))
              .matches(regex, errMsg)
          }
        ),
        invoiceEmail: Yup.string().when('vat', (vat, schema: any) => {
          if (vat[0]) {
            return schema
              .required(translate('invoiceEmailRequired'))
              .email(translate('invoiceEmailInvalid'))
          }
          return schema
        }),
        storeCode: Yup.string().when('shippingMethod', (item, schema: any) => {
          if (item[0] === SHIPPING_METHOD.PICKUP_IN_STORE) {
            return schema.required(translate('storeRequired'))
          }
          return schema
        }),
        provinceCode: Yup.string().when(
          'shippingMethod',
          (item, schema: any) => {
            if (item[0] == SHIPPING_METHOD.STANDARD)
              return schema.required(translate('provinceRequired'))
            return schema
          }
        ),
        districtCode: Yup.string().when(
          ['shippingMethod', 'areaType'],
          ([shippingMethod, areaType]: any[], schema: any) => {
            if (
              shippingMethod === SHIPPING_METHOD.STANDARD &&
              areaType !== 'new'
            )
              return schema.required(translate('districtRequired'))
            return schema
          }
        ),
        wardCode: Yup.string().when('shippingMethod', (item, schema: any) => {
          if (item[0] == SHIPPING_METHOD.STANDARD)
            return schema.required(translate('wardRequired'))
          return schema
        }),
        address: Yup.string().when('shippingMethod', (item, schema: any) => {
          if (item[0] == SHIPPING_METHOD.STANDARD)
            return schema.required(translate('addressRequired'))
          return schema
        }),
        paymentMethod: Yup.string()
          .required(translate('paymentMethodRequired'))
          .oneOf(
            [
              'COD',
              'atm',
              'bankTransfer',
              'qrcode',
              'creditCard',
              'installment',
            ],
            translate('paymentMethodInvalid')
          ),
        payment: Yup.object().shape({
          method: Yup.string()
            .required(translate('paymentMethodRequired'))
            .oneOf(
              [
                'COD',
                'atm',
                'bankTransfer',
                'qrcode',
                'creditCard',
                'installment',
              ],
              translate('paymentMethodInvalid')
            ),
        }),
      })
    case 'checkoutCard':
      return Yup.object({
        cardName: Yup.string().required('Vui lòng nhập'),
        // cardNumber: Yup.string()
        //   .trim()
        //   .transform(value => value.replace(/\s/g, ''))
        //   .required('Vui lòng nhập thông tin thẻ')
        //   .matches(/^\d{16}$/, 'Số thẻ không hợp lệ'),
        expire: Yup.string()
          .required('Vui lòng nhập ngày hết hạn')
          .matches(/^\d{2}\/\d{4}$/, 'Ngày hết hạn không hợp lệ'),
        // cvv: Yup.string()
        //   .required('Vui lòng nhập CVV')
        //   .matches(/^\d{3}$/, 'CVV không hợp lệ'),
      })
    case 'updateInfo':
      return Yup.object().shape({
        name: Yup.string().required(translate('nameRequired')),
        provinceCode: Yup.string().required(translate('provinceRequired')),
        districtCode: Yup.string().when('areaType', (areaType, schema: any) => {
          if ((areaType as any)?.[0] === 'old') {
            return schema.required(translate('districtRequired'))
          }
          return schema
        }),
        wardCode: Yup.string().required(translate('wardRequired')),
        address: Yup.string().required(translate('addressRequired')),
      })
    case 'paymentMethod':
      return Yup.object().shape({
        paymentMethod: Yup.string()
          .required(translate('paymentMethodRequired'))
          .oneOf(
            [
              'COD',
              'atm',
              'bankTransfer',
              'qrcode',
              'creditCard',
              'installment',
            ],
            translate('paymentMethodInvalid')
          ),
        bankType: Yup.string().when(
          'paymentMethod',
          (paymentMethod, schema: any) => {
            if (
              paymentMethod[0] === 'atm' ||
              paymentMethod[0] === 'bankTransfer'
            ) {
              return schema.required(translate('bankTypeRequired'))
            }
            return schema
          }
        ),
        bankCode: Yup.string().when(
          'paymentMethod',
          (paymentMethod, schema: any) => {
            if (
              paymentMethod[0] === 'atm' ||
              paymentMethod[0] === 'bankTransfer'
            ) {
              return schema.required(translate('bankCodeRequired'))
            }
            return schema
          }
        ),
      })
  }

  return schemaValidation
}
